import { formatNumberToCurrency } from '@/utils/currency';
import { Stack, Typography } from '@mui/material';
// import ArrowUpwardIcon from "@/components/icons/arrowUpward";
// import ArrowDownwardIcon from "@/components/icons/arrowDownward";

interface DashboardNetWorthInterface {
  totalValue?: number;
  otherValue?: number;
  percentage?: number;
  compareText: string;
  totalValueText?: string;
}

export default function ChartCurrencyTitle({
  totalValueText = '',
  totalValue = 0,
}: DashboardNetWorthInterface) {
  return (
    <Stack
      gap={1}
      direction='column'
      alignItems='flex-start'
    >
      <Stack
        direction='row'
        alignItems='baseline'
        gap={1}
        marginBottom={2}
      >
        <Typography variant='h4'>
          {formatNumberToCurrency(totalValue)}
        </Typography>
        <Typography variant='h6'>{totalValueText}</Typography>
      </Stack>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        Commented out percentage change text - may be added back later
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isPositive ? (
            <ArrowUpwardIcon fill={textColor} />
          ) : (
            <ArrowDownwardIcon fill={textColor} />
          )}
          <Typography
            variant="subtitle1"
            sx={{
              color: textColor,
              fontSize: "16px",
              lineHeight: "175%",
              letterSpacing: "0.15px",
            }}
          >
            {`${formatNumberToCurrency(Math.abs(otherValue))} (${formattedPercentage}%)`}
          </Typography>
        </Box>
      </Box> */}
    </Stack>
  );
}
